import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  WhatsappPages: [],
  isSuccess: false,
  message: null,
  status: "idle",
  error: null,
  IsLogin: true,
};
export const fetchWhatsappPages = createAsyncThunk("/Whatsapp/GetWAInstance", async () => {
  const response = await axiosInstanceAuth.get(`/Whatsapp/GetWAInstance?moduleName=${"CRM"}`);
  return response.data;
});

const WhatsappPageSlice = createSlice({
  name: "WhatsappPageSlice",
  initialState,
  reducers: {
    TagsAdded: {
      reducer(state, action) {
        state.WhatsappPages?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchWhatsappPages.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchWhatsappPages.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.WhatsappPages = action.payload.Data;
      })
      .addCase(fetchWhatsappPages.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getWhatsappPageDetails = state => state.WhatsappPageSlice;

export const { TagsAdded } = WhatsappPageSlice.actions;

export default WhatsappPageSlice.reducer;
